// extracted by mini-css-extract-plugin
export var mainLayout = "styles-module--mainLayout--ab2f4";